// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__25LAf"};